import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_11: FaireProductEntity = {
  token: "nyc-bev-11",
  type: "product",
  name: "Chelsea Chai Concentrate",
  brandName: "Chelsea Spice Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/259c9bd199b6fd0a69541bf48e154c8fc3c2fac8e7d39aa616b37fce6a955d32.webp",
  priceDollars: 10.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/259c9bd199b6fd0a69541bf48e154c8fc3c2fac8e7d39aa616b37fce6a955d32.webp",
  weight: 1.1,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  description: "Spiced chai concentrate from Chelsea",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "spicy", "tea"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
